import axios, { AxiosError } from 'axios';
import apiConfig from '@/config/url-api';
import { handleUnauthorized } from '@/api/axios/handleUnauthorized';

interface ErrorResponse {
  message: string;
  errors?: any;
}

export interface CustomError {
  error: AxiosError;
  status?: number;
  data?: ErrorResponse | null;
  message: string;
  isUnauthorized?: boolean;
  isCanceled?: boolean;
}

const errorResponseHandler = (error: AxiosError): Promise<CustomError> => {
  // If request was cancelled (e.g. aborted due to expired session), reject cleanly without toast
  if (axios.isCancel(error)) {
    return Promise.reject({
      error,
      isCanceled: true,
      message: 'Request canceled',
    });
  }

  if (error && error.response) {
    // @ts-ignore
    const { status, data }: { status: number; data: ErrorResponse } = error.response;
    const url = error.config?.url || '';
    const isLoginEndpoint = url.includes(apiConfig.auth.login) || url.includes('/login');

    if (status === 401 && !isLoginEndpoint) {
      handleUnauthorized(error);
      return Promise.reject({
        error,
        status: 401,
        isUnauthorized: true,
        data: data ? data : null,
        message: data?.message || 'Sesi Anda telah berakhir, silakan login kembali.',
      });
    }

    return Promise.reject({
      error,
      status,
      data: data ? data : null,
      message: data ? data.message : 'Terjadi kesalahan saat memproses permintaan.',
    });
  }

  if (error?.code === 'ERR_NETWORK') {
    return Promise.reject({
      error,
      message: 'Terjadi kesalahan, periksa kembali koneksi anda',
    });
  }

  return Promise.reject({
    error,
    message: 'Terjadi kesalahan',
  });
};

export default errorResponseHandler;
